module.exports = __webpack_public_path__ + "static/media/P1000-sm-close.7d855cc0.svg";